module.exports = __webpack_public_path__ + "img/幸運_四方連續_彩稿.18923cb0.png";